/* ==========================================================================
   Element 5 — Custom Cart Drawer controller (Rebuy clone)
   ========================================================================== */
(function () {
  'use strict';

  var DEBOUNCE = 120;
  var TESTI_INTERVAL = 6000;
  // Sections to ask the Cart AJAX API to render inline with a mutation, so a
  // single /cart/add|change|update round-trip returns BOTH the updated cart
  // AND the re-rendered drawer + icon HTML — no separate refresh fetches.
  var SECTIONS = 'cart-drawer,cart-icon-bubble';
  // Capture the native fetch up front. All of the drawer's OWN cart requests
  // use this, so they bypass the window.fetch wrapper we install for the
  // product-page add interception below (see armExternalAddIntercept).
  var NATIVE_FETCH = window.fetch.bind(window);
  // NMN bundle: each supply size is a Shopify variant. The cart holds ONE bundle
  // line per purchase type (subscription / one-time), sized to the total months
  // of that type; +/- steps the size, "add one more" grows it by a bottle (2mo).
  var E5_BUNDLE = {
    productId: 15992878727498,
    base2mo: 3499, // RRP basis: full one-off price of a single 2-month unit (pence)
    sub: 0.80,     // subscription = 20% off the variant price
    // months -> { v: variantId, p: sellingPlanId, price: one-time pence }
    sizes: {
      2:  { v: 63312011264330, p: 693313732938, price: 3499 },
      4:  { v: 63312011297098, p: 693313798474, price: 5950 },
      6:  { v: 63312011329866, p: 693313831242, price: 8400 },
      8:  { v: 63312011362634, p: 693313864010, price: 11200 },
      10: { v: 63312011395402, p: 693313929546, price: 14000 },
      12: { v: 63312011428170, p: 693313896778, price: 16800 }
    }
  };
  function e5bMonthsForVariant(vid) { vid = parseInt(vid, 10); var s = E5_BUNDLE.sizes; for (var k in s) { if (s[k].v === vid) return parseInt(k, 10); } return 0; }
  function e5bVariantFor(m) { return E5_BUNDLE.sizes[m] ? E5_BUNDLE.sizes[m].v : 0; }
  function e5bPlanFor(m) { return E5_BUNDLE.sizes[m] ? E5_BUNDLE.sizes[m].p : 0; }
  function e5bUid() { return String(Date.now()) + '-' + Math.random().toString(36).slice(2, 8); }
  function e5bSavePct(m, isSub) { var s = E5_BUNDLE.sizes[m]; if (!s) return 0; var rrp = (m / 2) * E5_BUNDLE.base2mo; var now = isSub ? Math.round(s.price * E5_BUNDLE.sub) : s.price; return Math.round((1 - now / rrp) * 100); }

  var TESTIMONIALS = [
    { quote: "More energy in 6 weeks than I've had in 10 years", name: 'Rachel, 54' },
    { quote: 'Less brain fog, more energy, better sleep', name: 'Lena' },
    { quote: 'This is magic in a bottle.', name: 'Kathleen' },
    { quote: 'I have energy that I thought had gone forever', name: 'Samantha' },
  ];

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
        style: 'currency',
        currency: currency || 'GBP',
      }).format((cents || 0) / 100);
    } catch (e) {
      return '£' + ((cents || 0) / 100).toFixed(2);
    }
  }

  function pub(data) {
    try {
      if (window.publish && window.PUB_SUB_EVENTS) {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, data);
      }
    } catch (e) {}
  }

  class E5CartDrawer extends HTMLElement {
    constructor() {
      super();
      this._chain = Promise.resolve(); // serialises all cart mutations
      this._giftBusy = false;
      this._qtyTimers = {};
      this._testiIndex = 0;
      this.activeElement = null;
    }

    connectedCallback() {
      // Header cart icon opens our drawer
      var icon = document.querySelector('#cart-icon-bubble');
      if (icon && !icon.dataset.e5Bound) {
        icon.dataset.e5Bound = '1';
        icon.setAttribute('role', 'button');
        icon.setAttribute('aria-haspopup', 'dialog');
        icon.addEventListener('click', (e) => { e.preventDefault(); this.open(icon); });
      }

      // Delegated events (survive innerHTML refresh)
      this.addEventListener('click', this.onClick.bind(this));
      this.addEventListener('change', this.onChange.bind(this));
      this.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') this.close();
        if (e.key === 'Enter' && e.target.matches('[data-e5-discount-input]')) {
          e.preventDefault();
          this.applyDiscount();
        }
      });
      var overlay = this.querySelector('#CartDrawer-Overlay');
      if (overlay) overlay.addEventListener('click', () => this.close());

      // 'toggle' doesn't bubble, but capturing listeners still see it on the
      // path down to the target — catch it here for any <details> we render.
      this.addEventListener('toggle', this.onToggle.bind(this), true);

      // Intercept product-page add-to-cart so it opens the drawer in place
      // instead of navigating to /cart and bouncing back (a full reload).
      this.armExternalAddIntercept();

      // The bundles page (and any other legacy Rebuy-era add scripts) run
      // their OWN fetch('/cart/add.js') — handling their own button state and
      // analytics — then fire a `rebuy:cart.open` CustomEvent to open the
      // cart, instead of redirecting. Rebuy is disabled, so nothing listened
      // for it and the drawer never opened (the item WAS added; it only
      // "showed up" later when the theme's generic cartUpdate pub/sub happened
      // to fire our refresh). We deliberately DON'T intercept those adds (so
      // their "Added ✓" feedback + any pixel events keep working) — we just
      // honour the open event they already emit. Their add didn't request our
      // `sections`, so refresh from the server, then open. Open immediately in
      // parallel with a loading state so the customer gets instant feedback.
      var self = this;
      document.addEventListener('rebuy:cart.open', function () {
        self.open();
        self.setLoading(true);
        self.refresh().then(function () { self.setLoading(false); self.syncGifts(); });
      });

      // React to cart changes from elsewhere (cart page, other apps)
      try {
        if (window.subscribe && window.PUB_SUB_EVENTS) {
          this._unsub = window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, (ev) => {
            if (ev && ev.source === 'e5-cart-drawer') return;
            this.refresh().then(() => this.syncGifts());
          });
        }
      } catch (e) {}

      // Several per-product custom add-to-cart scripts on this site (the
      // "pf-"/"e5sk" bespoke product sections) hardcode a redirect to /cart
      // after adding, instead of checking cart_type. Since cart_type is
      // 'drawer' sitewide, a full navigation to /cart should never happen.
      // Just rewriting the URL bar isn't enough — the actual rendered DOM is
      // still Dawn's bare /cart page underneath our drawer, which reads as
      // "both the drawer AND the cart page opened". So bounce back with a
      // REAL navigation to the page the customer was on (location.replace,
      // no new history entry) and flag it to reopen the drawer once that
      // page has freshly loaded. A blocking head script (layout/theme.liquid)
      // hides this /cart landing instantly, so the bounce is invisible.
      if (/^\/cart\/?$/.test(window.location.pathname)) {
        var back = '/';
        try {
          var ref = document.referrer;
          if (ref && new URL(ref).origin === window.location.origin) {
            back = new URL(ref).pathname + new URL(ref).search;
          }
        } catch (e) {}
        try { sessionStorage.setItem('e5cd_reopen', '1'); } catch (e) {}
        window.location.replace(back);
        return;
      }

      // Landed here via the bounce-back above — the cart already has the
      // item (added before the redirect), so reopen the drawer once this
      // page's own init below has run.
      var reopenAfterLoad = false;
      try {
        if (sessionStorage.getItem('e5cd_reopen') === '1') {
          sessionStorage.removeItem('e5cd_reopen');
          reopenAfterLoad = true;
        }
      } catch (e) {}

      this.renderGoals();
      this.renderGiftSubtotal();
      if (this.querySelector('[data-e5-banner]')) this.startTestimonials();
      // Covers customers arriving via a discount link (?discount=/discount/CODE)
      // whose code is already on the cart before any mutation happens here.
      this.refreshDiscountChips();
      // Validate gift state on load (removes unqualified manual gifts, etc.)
      this.syncGifts();
      // Strip any stale Rebuy Smart Cart attributes off the persisted cart so
      // they can't ride onto a brand-new order (see clearRebuyAttributes).
      this.clearRebuyAttributes();
      this.enforceTrialQty();

      if (reopenAfterLoad) this.open();
    }

    disconnectedCallback() {
      if (this._unsub) this._unsub();
      clearInterval(this._testiInt);
      clearInterval(this._timerInt);
    }

    /* ---------------- data island helpers ---------------- */
    get data() { return this.querySelector('.e5cd__data'); }
    routes() {
      var d = this.data;
      return {
        add: (d && d.dataset.cartRoutesAdd) || (window.routes && routes.cart_add_url) || '/cart/add.js',
        change: (d && d.dataset.cartRoutesChange) || (window.routes && routes.cart_change_url) || '/cart/change.js',
        update: (d && d.dataset.cartRoutesUpdate) || (window.routes && routes.cart_update_url) || '/cart/update.js',
        cart: (window.routes && routes.cart_url) || '/cart',
      };
    }
    qualifyingTotal() { var d = this.data; return d ? parseInt(d.dataset.qualifyingTotal, 10) || 0 : 0; }
    currency() { var d = this.data; return d ? d.dataset.currency || 'GBP' : 'GBP'; }
    goals() {
      var d = this.data;
      if (!d) return [];
      try { return JSON.parse(d.dataset.goals || '[]'); } catch (e) { return []; }
    }

    /* ---------------- open / close ---------------- */
    setActiveElement(el) { this.activeElement = el; }

    open(trigger) {
      if (trigger) this.setActiveElement(trigger);
      var self = this;
      // rAF first so the open slides (lets the browser paint the closed state
      // before flipping to open). But rAF never fires while the tab is
      // backgrounded, so a setTimeout fallback guarantees the drawer still
      // opens (just without the slide) in that edge case.
      requestAnimationFrame(() => self.classList.add('animate', 'active'));
      setTimeout(() => self.classList.add('animate', 'active'), 60);
      document.body.classList.add('overflow-hidden');
      var panel = this.querySelector('.e5cd__panel');
      if (panel) setTimeout(() => panel.focus(), 350);
    }

    close() {
      this.classList.remove('active');
      document.body.classList.remove('overflow-hidden');
      if (this.activeElement && this.activeElement.focus) this.activeElement.focus();
    }

    setLoading(on) { this.classList.toggle('is-loading', !!on); }

    /* ---------------- product-form.js contract ---------------- */
    getSectionsToRender() { return [{ id: 'cart-drawer' }, { id: 'cart-icon-bubble' }]; }

    renderContents(response) {
      if (response && response.sections && response.sections['cart-drawer']) {
        this.applySectionHTML(response.sections['cart-drawer']);
        if (response.sections['cart-icon-bubble']) this.applyIcon(response.sections['cart-icon-bubble']);
        this.renderGoals();
        this.refreshDiscountChips();
        this.open();
        this.syncGifts();
      } else {
        this.refresh().then(() => { this.open(); this.syncGifts(); });
      }
    }

    /* ---------------- product-page add interception ---------------- */
    // The bespoke per-product "pf-"/"e5sk" add-to-cart scripts do their own
    // fetch('/cart/add.js', {body}) and THEN window.location.href='/cart'. We
    // can't cancel that redirect from outside, and we don't want to
    // reimplement each product's variant/qty/plan selection. So instead we
    // wrap window.fetch: when one of those add calls fires (armed by a click
    // on the known CTA a moment earlier), we run the REAL add ourselves —
    // with `sections` so we get the drawer HTML back — open the drawer, and
    // hand the caller a promise that never settles. Their `.then(redirect)`
    // therefore never runs: no navigation, no reload, drawer just opens.
    // Our own cart requests use NATIVE_FETCH, so they're never intercepted;
    // the bounce-back in connectedCallback stays as a fallback for any add
    // path this doesn't catch (e.g. one using XHR).
    armExternalAddIntercept() {
      var self = this;
      // Arm only immediately after a click on a bespoke product CTA. Capture
      // the button + its label/disabled state NOW (before the pf handler flips
      // it to "Adding..." and disables it) so we can restore it afterwards —
      // otherwise, since we suppress the pf handler's continuation, the button
      // would stay stuck on "Adding..." until a page reload.
      document.addEventListener('click', function (e) {
        var t = e.target && e.target.closest && e.target.closest('#pfCta, #e5skBtn, .pf-cta, .e5sk-btn');
        if (t) {
          self._pfClickAt = Date.now();
          self._pfBtn = t;
          self._pfBtnText = t.textContent;
          self._pfBtnDisabled = t.disabled;
        }
      }, true);

      if (window.__e5FetchWrapped) return;
      window.__e5FetchWrapped = true;

      window.fetch = function (input, init) {
        try {
          var url = typeof input === 'string' ? input : (input && input.url) || '';
          var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
          var armed = self._pfClickAt && (Date.now() - self._pfClickAt < 2000);
          if (armed && method === 'POST' && /\/cart\/add(\.js)?(\?|$)/.test(url) && init && typeof init.body === 'string') {
            self._pfClickAt = 0; // one-shot per click
            var newInit = init;
            try {
              var payload = JSON.parse(init.body);
              payload.sections = SECTIONS;
              payload.sections_url = window.location.pathname;
              // NMN bundle: each product-page add is its OWN line (never merged).
              // A hidden unique tag keeps identical size+plan adds as separate lines.
              (payload.items || []).forEach(function (it) {
                if (e5bMonthsForVariant(it.id)) { it.properties = it.properties || {}; it.properties._e5line = e5bUid(); }
              });
              newInit = Object.assign({}, init, { body: JSON.stringify(payload) });
            } catch (e) { /* non-JSON body — send as-is, just won't get sections */ }

            NATIVE_FETCH(input, newInit)
              .then(function (r) { return r.ok ? r.json() : r.json().catch(function () { return null; }); })
              .then(function (res) {
                self.restorePfBtn();
                self.open();
                // NMN bundle: enforce a single supply line (a different supply/plan
                // replaces the previous one). Any other product renders normally.
                if (!self.applyResult(res)) { self.refresh(); }
                self.renderCartBits(res).then(function (c) { pub({ source: 'e5-cart-drawer' }); self.syncGifts(c); });
              })
              .catch(function (err) {
                // Our own add failed — surface it in the drawer rather than
                // doing a pointless /cart bounce (the item didn't land).
                console.error('[e5-cart] external add intercept', err);
                self.restorePfBtn();
                self.open();
                self.showMutationError('Sorry, we couldn’t add that to your cart. Please try again.');
              });

            // Never settle: suppresses the caller's post-add redirect.
            return new Promise(function () {});
          }
        } catch (e) { /* fall through to native */ }
        return NATIVE_FETCH.apply(this, arguments);
      };
    }

    // Put the bespoke product CTA back the way it was before the pf handler
    // flipped it to "Adding..."/disabled. We suppress that handler's own
    // continuation (never-settling promise), so nothing else resets it.
    restorePfBtn() {
      var b = this._pfBtn;
      if (!b) return;
      try {
        if (this._pfBtnText != null) b.textContent = this._pfBtnText;
        b.disabled = !!this._pfBtnDisabled;
        b.classList.remove('loading', 'is-loading', 'is-adding', 'disabled');
        b.removeAttribute('aria-busy');
      } catch (e) { /* best effort */ }
      this._pfBtn = null; this._pfBtnText = null; this._pfBtnDisabled = false;
    }

    /* ---------------- rendering ---------------- */
    applySectionHTML(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('#CartDrawer');
      var cur = this.querySelector('#CartDrawer');
      // Preserve scroll position across the re-render. Replacing #CartDrawer's
      // innerHTML destroys and recreates .e5cd__body (the scroll container), which
      // resets its scrollTop to 0 — that's what yanked the shopper back to the top
      // on every qty/subscribe/discount change. Capture it first, restore it onto
      // the fresh body (the browser clamps to the new max if the cart got shorter).
      var prevBody = this.querySelector('.e5cd__body');
      var prevScroll = prevBody ? prevBody.scrollTop : 0;
      if (fresh && cur) cur.innerHTML = fresh.innerHTML;
      if (prevScroll) {
        var newBody = this.querySelector('.e5cd__body');
        if (newBody) newBody.scrollTop = prevScroll;
      }
      var freshRoot = doc.querySelector('cart-drawer');
      if (freshRoot) this.classList.toggle('is-empty', freshRoot.classList.contains('is-empty'));
      // #CartDrawer's innerHTML was just replaced — repaint the testimonial
      // that was mid-rotation into the fresh banner node.
      this.paintTestimonial(false);
      this.renderGiftSubtotal();
      this.paintBundleHints();
      // Dynamic checkout buttons (Shop Pay / Apple Pay etc.) are wired up by
      // Shopify on page load; replacing #CartDrawer's innerHTML leaves the
      // fresh markup inert, so re-init them after every render.
      try { if (window.Shopify && Shopify.PaymentButton && Shopify.PaymentButton.init) Shopify.PaymentButton.init(); } catch (e) {}
      this.enforceTrialQty();
    }

    // Free-trial lines (data-e5-trial, from products tagged trial-offer) are one
    // per order. The drawer shows no stepper for them, but a second click on the
    // product page's claim button adds another unit — snap any trial line back to 1.
    enforceTrialQty() {
      if (this._trialFixing) return;
      var over = Array.prototype.filter.call(this.querySelectorAll('[data-e5-trial]'), function (l) {
        return (parseInt(l.dataset.qty, 10) || 0) > 1;
      });
      if (!over.length) return;
      var self = this, key = over[0].dataset.lineKey;
      this._trialFixing = true;
      this.enqueue(function () { return self.changeLine(key, 1); }).then(function () {
        self._trialFixing = false;
        self.showMutationError('Free trial offers are limited to one per order.');
      });
    }

    // "You've got £X worth of free gifts!" banner above the gift lines.
    // Liquid emits the raw pence value as a data attribute rather than
    // rendering the money text directly — this store's shop.money_format is
    // a bare "{{amount}}" with no currency symbol, so any Liquid `| money`
    // output silently comes out as "79.98" instead of "£79.98". The JS
    // money() helper (Intl.NumberFormat) is the only reliable way to show a
    // currency symbol here — same reason renderSubtotal()/renderDiscountChips()
    // already build their text in JS instead of trusting server-rendered HTML.
    renderGiftSubtotal() {
      var el = this.querySelector('[data-e5-gift-subtotal]');
      var value = el ? (parseInt(el.getAttribute('data-value'), 10) || 0) : 0;
      var giftCount = this.querySelectorAll('.e5cd__line--gift').length;

      // Reassurance perk near the subtotal: pluralise + show total gift value.
      var perk = this.querySelector('[data-e5-gift-perk]');
      if (perk) {
        var perkTxt = perk.querySelector('[data-e5-gift-perk-text]');
        if (giftCount > 0 && value > 0) {
          perk.style.display = '';
          if (perkTxt) perkTxt.textContent = (giftCount > 1 ? 'Free gifts' : 'Free gift') + ' worth ' + money(value, this.currency());
        } else {
          perk.style.display = 'none';
        }
      }

      if (!el) return;
      el.textContent = value > 0 ? (money(value, this.currency()) + ' value') : '';
    }

    applyIcon(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var src = doc.querySelector('.shopify-section') || doc.body;
      var target = document.getElementById('cart-icon-bubble');
      if (src && target) target.innerHTML = src.innerHTML;
    }

    // Full re-fetch used for external cart-update events and the error-path
    // resync. The two section renders and /cart.js run in PARALLEL (they were
    // sequential before — 3 chained round-trips), so this is ~1 round-trip of
    // latency instead of 3. Normal in-drawer mutations don't call this at all
    // now — they render straight from the mutation response (see applyResult).
    // Pass `cartData` to reuse an already-fetched cart and skip the /cart.js.
    refresh(cartData) {
      var self = this;
      var base = this.routes().cart;
      var pDrawer = NATIVE_FETCH(base + '?section_id=cart-drawer').then((r) => r.text());
      var pIcon = NATIVE_FETCH(base + '?section_id=cart-icon-bubble').then((r) => r.text());
      var pCart = cartData
        ? Promise.resolve(cartData)
        : NATIVE_FETCH(base + '.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      return Promise.all([pDrawer, pIcon, pCart])
        .then((res) => {
          self.applySectionHTML(res[0]);
          self.renderGoals();
          self.applyIcon(res[1]);
          self.renderDiscountChips(res[2]);
          self.renderSubtotal(res[2]);
        })
        .catch((e) => console.error('[e5-cart] refresh', e));
    }

    // Apply the re-rendered section HTML that came back INLINE with a cart
    // mutation (the `sections` param on add/change/update). This is what makes
    // in-drawer actions feel instant: the drawer + icon repaint from the same
    // response that performed the mutation, no follow-up fetch.
    applyResult(res) {
      if (!res || !res.sections) return false;
      if (res.sections['cart-drawer']) this.applySectionHTML(res.sections['cart-drawer']);
      if (res.sections['cart-icon-bubble']) this.applyIcon(res.sections['cart-icon-bubble']);
      this.renderGoals();
      return true;
    }

    // Render the discount chips + subtotal from a mutation response when it's a
    // full cart (change/update responses include items + discount_codes), else
    // fall back to one /cart.js fetch (add.js responses don't carry the cart).
    // Returns the cart object either way (for syncGifts to reuse).
    renderCartBits(res) {
      var self = this;
      if (res && res.items && res.discount_codes !== undefined) {
        this.renderDiscountChips(res);
        this.renderSubtotal(res);
        return Promise.resolve(res);
      }
      return NATIVE_FETCH(this.routes().cart + '.js', { headers: { Accept: 'application/json' } })
        .then((r) => r.json())
        .then((cart) => { self.renderDiscountChips(cart); self.renderSubtotal(cart); return cart; })
        .catch((e) => { console.error('[e5-cart] cart bits', e); return null; });
    }

    /* ---------------- discount chips (client-rendered) ---------------- */
    // Liquid's cart.discount_codes doesn't reliably reflect codes applied via
    // the Cart AJAX API's `discount` field on /cart/update.js — only /cart.js
    // (this fetch) does. So the chip + open/closed state are driven from here,
    // not from the server-rendered section.
    renderDiscountChips(cart) {
      var panel = this.querySelector('[data-e5-discount]');
      var chipsWrap = this.querySelector('[data-e5-discount-chips]');
      var totalRow = this.querySelector('[data-e5-discount-total]');
      if (!chipsWrap) return;
      var codes = (cart && cart.discount_codes) || [];

      // Hide the "tap for a mystery discount" prompt once any code is applied,
      // and bring it back if all codes are removed.
      var myst = this.querySelector('.e5cd__mystery');
      if (myst) { myst.style.display = codes.length ? 'none' : ''; myst.classList.remove('is-revealing'); }

      chipsWrap.innerHTML = codes.map((dc) => {
        var safeCode = String(dc.code).replace(/"/g, '&quot;');
        return '<span class="e5cd__chip' + (dc.applicable ? '' : ' e5cd__chip--invalid') + '">' +
          dc.code +
          '<button type="button" data-e5-action="remove-discount" data-code="' + safeCode + '" aria-label="Remove ' + dc.code + '">&times;</button>' +
          '</span>';
      }).join('');

      if (codes.length && panel) { panel.hidden = false; }
      var dtl = this.querySelector('[data-e5-disc-toggle-label]');
      if (dtl && panel) dtl.textContent = panel.hidden ? '+ Add Discount Code' : '− Hide Discount Code';

      if (totalRow) {
        var applicable = codes.filter((dc) => dc.applicable).map((dc) => dc.code);
        // cart.total_discount is EVERY discount stacked (this code, plus any
        // automatic "Buy More Save More" / "Multi-Buy Subscribe & Save"
        // volume-tier discounts) — using it here mislabels automatic
        // discounts as if the customer's code caused all of it (confirmed
        // live: a 10% code showed as "-£19.42" on an order where volume
        // tiers accounted for most of that). Sum only the per-line discount
        // allocations whose title matches an actually-applied code.
        var codeDiscountTotal = 0;
        (cart && cart.items || []).forEach((item) => {
          (item.discounts || []).forEach((d) => {
            if (applicable.indexOf(d.title) !== -1) codeDiscountTotal += d.amount;
          });
        });
        if (codeDiscountTotal > 0 && applicable.length) {
          var label = applicable.length > 1 ? applicable.join(' + ') : applicable[0];
          totalRow.hidden = false;
          totalRow.innerHTML = '<span>Discount (' + label + ')</span><span>−' + money(codeDiscountTotal, cart.currency) + '</span>';
        } else {
          totalRow.hidden = true;
          totalRow.innerHTML = '';
        }
      }
    }

    // Same reliability issue as the discount chips: cart.total_price in the
    // server-rendered section doesn't reflect AJAX-applied discount codes.
    // Read /cart.js instead so the subtotal always matches what checkout will
    // actually charge. Line items themselves are never touched here — they
    // always show their full per-bottle price regardless of any code.
    renderSubtotal(cart) {
      var nowEl = this.querySelector('[data-e5-subtotal-now]');
      var wasEl = this.querySelector('[data-e5-subtotal-was]');
      if (!nowEl || !cart) return;
      var giftVariantIds = this.goals()
        .filter((g) => g.reward_type === 'free_gift' && g.gift_variant_id)
        .map((g) => g.gift_variant_id);
      var compareTotal = 0;
      (cart.items || []).forEach((item) => {
        if (giftVariantIds.indexOf(item.variant_id) === -1) {
          compareTotal += item.original_line_price || item.line_price || 0;
        }
      });
      nowEl.textContent = money(cart.total_price, cart.currency);
      if (wasEl) {
        if (compareTotal > cart.total_price) {
          wasEl.hidden = false;
          wasEl.textContent = money(compareTotal, cart.currency);
        } else {
          wasEl.hidden = true;
        }
      }
    }

    refreshDiscountChips() {
      var self = this;
      return NATIVE_FETCH(this.routes().cart + '.js', { headers: { Accept: 'application/json' } })
        .then((r) => r.json())
        .then((cart) => {
          self.renderDiscountChips(cart);
          self.renderSubtotal(cart);
        })
        .catch((e) => console.error('[e5-cart] discount refresh', e));
    }

    /* ---------------- legacy Rebuy attribute scrub ---------------- */
    // Rebuy's old Smart Cart stamped these note attributes onto the cart.
    // Rebuy is retired from the storefront, but a returning customer's
    // persisted cart can still carry them from that era — and they'd ride
    // through THIS drawer onto a brand-new order, which Rebuy then claims in
    // its dashboard. Strip them (only when actually present) so new cart-path
    // orders are Rebuy-free. Setting a cart attribute to '' removes it.
    // NOTE: this cannot touch Recharge subscription REBILLS — those are
    // generated server-side from the subscription's stored attributes and
    // never pass through the cart; clean those in Recharge if needed.
    clearRebuyAttributes(cart) {
      var self = this;
      var get = (cart && cart.attributes)
        ? Promise.resolve(cart)
        : NATIVE_FETCH(this.routes().cart + '.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      return get
        .then((c) => {
          var attrs = (c && c.attributes) || {};
          var clear = {};
          // Only clear _source when it's actually Rebuy's — other tools use
          // _source too (e.g. UTM/campaign sources) and must be left alone.
          if (String(attrs._source || '').toLowerCase() === 'rebuy') clear._source = '';
          if (/smart\s*cart/i.test(String(attrs._attribution || ''))) clear._attribution = '';
          if (attrs._barId) clear._barId = ''; // _barId is Rebuy-specific
          if (!Object.keys(clear).length) return false; // nothing to do — common case
          // No `sections` needed: this changes no visible items or totals.
          return self.postJSON(self.routes().update, { attributes: clear }).then(() => true);
        })
        .catch((e) => console.error('[e5-cart] clear rebuy attrs', e));
    }

    /* ---------------- rotating testimonial banner ---------------- */
    paintTestimonial(fade) {
      var node = this.querySelector('[data-e5-banner]');
      if (!node) return;
      var t = TESTIMONIALS[this._testiIndex % TESTIMONIALS.length];
      var html =
        '<span class="e5cd__testi-stars" aria-hidden="true">★★★★★</span>' +
        '<span class="e5cd__testi-text">“' + t.quote + '”</span>' +
        '<span class="e5cd__testi-name">' + t.name + ', Verified <svg class="e5cd__testi-check" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 12.5l5 5L20 6" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg></span>' +
        '<span class="e5cd__testi-progress" style="animation-duration:' + TESTI_INTERVAL + 'ms"></span>';
      if (!fade) { node.innerHTML = html; return; }
      node.classList.add('is-fading');
      var self = this;
      setTimeout(function () {
        var node2 = self.querySelector('[data-e5-banner]');
        if (!node2) return;
        node2.innerHTML = html;
        node2.classList.remove('is-fading');
      }, 200);
    }

    startTestimonials() {
      this.paintTestimonial(false);
      var self = this;
      clearInterval(this._testiInt);
      this._testiInt = setInterval(function () {
        self._testiIndex = (self._testiIndex + 1) % TESTIMONIALS.length;
        self.paintTestimonial(true);
      }, TESTI_INTERVAL);
    }

    /* ---------------- goal tracker (Rebuy-style, collapsible) ---------------- */
    renderGoals() {
      var root = this.querySelector('[data-e5-goal-root]');
      if (!root) { this.renderTimer(); return; }
      var goals = this.goals().slice().sort((a, b) => a.threshold - b.threshold);

      if (!goals.length) { root.innerHTML = ''; this.renderTimer(); return; }
      // Cart holds only no-cart-rewards items (e.g. ATOM pre-order): hide the ladder.
      if (this.data && this.data.dataset.rewardsExcludedOnly === 'true') { root.innerHTML = ''; this.renderTimer(); return; }

      var total = this.qualifyingTotal();
      var cur = this.currency();
      var n = goals.length;
      var hitCount = goals.filter((g) => total >= g.threshold).length;
      var pct;
      if (hitCount >= n) {
        pct = 100;
      } else {
        var idx = hitCount;
        var segStart = idx === 0 ? 0 : goals[idx - 1].threshold;
        var segEnd = goals[idx].threshold;
        var segProgress = segEnd > segStart ? Math.max(0, Math.min(1, (total - segStart) / (segEnd - segStart))) : 1;
        // Fill lands on the CENTRE of the met icon: with n equal tiles, the last-met
        // tile's centre is (idx - 0.5)/n; interpolate toward the next tile's centre
        // by segProgress. So a met goal sits mid-icon, not overshooting past it.
        pct = Math.max(0, ((idx - 0.5 + segProgress) / n) * 100);
      }

      var wonValue = goals.reduce((s, g) => s + (total >= g.threshold ? (g.value || 0) : 0), 0);

      var tiles = goals.map((g) => {
        var hit = total >= g.threshold;
        var label = (g.label || (g.reward_type === 'free_gift' ? 'Free gift' : 'Free shipping')).replace(/^Free\s+/i, '');
        label = label.charAt(0).toUpperCase() + label.slice(1);
        var thumb;
        if (g.reward_type === 'free_shipping') thumb = '<span class="e5cd__lt-ic">🚚</span>';
        else if (g.reward_type === 'express_shipping') thumb = '<span class="e5cd__lt-ic">⚡</span>';
        else thumb = (g.image ? '<img src="' + g.image + '" alt="" loading="lazy">' : '<span class="e5cd__lt-im"></span>');
        var mark = hit ? '<span class="e5cd__lt-chk">✓</span>' : '<span class="e5cd__lt-lock">🔒</span>';
        return '<div class="e5cd__lt' + (hit ? '' : ' is-locked') + '">' +
          '<div class="e5cd__lt-thumb">' + thumb + mark + '</div>' +
          '<div class="e5cd__lt-nm">' + label + '</div></div>';
      }).join('');

      var next = goals.find((g) => total < g.threshold);
      var msg;
      if (next) {
        var remaining = money(next.threshold - total, cur);
        var tmpl = next.progress_message || "You're {{amount}} away from your reward";
        msg = tmpl.replace('{{amount}}', '<strong>' + remaining + '</strong>');
      } else {
        msg = goals[goals.length - 1].unlocked_message || 'All rewards unlocked 🎉';
      }

      var head = wonValue > 0
        ? '🎁 Free Gifts <s class="e5cd__ws">' + money(wonValue, cur) + '</s> <span class="e5cd__paid">' + money(0, cur) + '</span>'
        : '🎁 Your rewards';
      var cols = Math.min(n, 6);

      root.innerHTML =
        '<div class="e5cd__lhead">' + head + '</div>' +
        '<div class="e5cd__lgrid" style="grid-template-columns:repeat(' + cols + ',1fr)">' + tiles + '</div>' +
        '<div class="e5cd__lbar"><i style="width:' + pct + '%"></i></div>' +
        '<div class="e5cd__lmsg">' + msg + '</div>';

      this.renderTimer();
    }

    toggleGoal() {
      var root = this.querySelector('[data-e5-goal-root]');
      if (!root) return;
      var collapsed = !root.classList.contains('is-collapsed');
      root.classList.toggle('is-collapsed', collapsed);
      try { localStorage.setItem('e5cd_goal_collapsed', collapsed ? '1' : '0'); } catch (e) {}
      var compact = root.querySelector('.e5cd__goal-compact');
      var msg = root.querySelector('.e5cd__goal-msg');
      if (compact && msg) compact.innerHTML = collapsed ? msg.innerHTML : 'Your rewards';
      var btn = root.querySelector('[data-e5-action="toggle-goal"]');
      if (btn) { btn.textContent = collapsed ? 'Show' : 'Hide'; btn.setAttribute('aria-expanded', String(!collapsed)); }
    }

    /* ---------------- urgency countdown ("order reserved" style) ---------------- */
    // Once a session's countdown genuinely reaches zero, remove it rather than
    // freezing at 0:00 or silently restarting a fresh countdown next render —
    // a timer that keeps resetting isn't urgent, it's just decorative.
    renderTimer() {
      var el = this.querySelector('[data-e5-timer]');
      if (!el) { clearInterval(this._timerInt); return; }
      var mins = parseInt(el.getAttribute('data-minutes'), 10) || 10;
      var KEY = 'e5cd_timer_end';
      var end = parseInt(sessionStorage.getItem(KEY) || '0', 10);
      var now = Date.now();
      if (end && end < now) { el.remove(); clearInterval(this._timerInt); return; }
      if (!end) { end = now + mins * 60000; try { sessionStorage.setItem(KEY, String(end)); } catch (e) {} }
      clearInterval(this._timerInt);
      var self = this;
      function tick() {
        var rem = end - Date.now();
        if (rem <= 0) {
          clearInterval(self._timerInt);
          var node = self.querySelector('[data-e5-timer]');
          if (node) node.remove();
          return;
        }
        var m = Math.floor(rem / 60000);
        var sec = Math.floor((rem % 60000) / 1000);
        el.innerHTML = '<span class="e5cd__timer-check">✓</span>Deals below expire in <strong>' + m + ':' + (sec < 10 ? '0' : '') + sec + '</strong>';
      }
      tick();
      this._timerInt = setInterval(tick, 1000);
    }

    /* ---------------- mutation primitives (serialised) ---------------- */
    // Shopify's Cart API returns a non-2xx with a JSON body describing what
    // went wrong (e.g. requesting more than available stock). Previously
    // nothing checked r.ok, so callers' `.then(r => r.json())` happily
    // parsed the ERROR body as if it were a normal response — the mutation
    // silently "succeeded" from the UI's perspective while the server had
    // actually rejected it. Reject here instead, with the server's own
    // description, so enqueue() below can surface it.
    postJSON(url, body) {
      return NATIVE_FETCH(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      }).then((r) => {
        if (r.ok) return r;
        return r.json().catch(() => ({})).then((data) => {
          throw new Error((data && (data.description || data.message)) || 'Something went wrong updating your cart.');
        });
      });
    }

    showMutationError(message) {
      var el = this.querySelector('[data-e5-mutation-error]');
      if (!el) return;
      el.textContent = message || 'Something went wrong updating your cart. Please try again.';
      el.hidden = false;
      clearTimeout(this._mutationErrTimer);
      this._mutationErrTimer = setTimeout(() => { el.hidden = true; }, 6000);
    }

    hideMutationError() {
      var el = this.querySelector('[data-e5-mutation-error]');
      if (el) el.hidden = true;
    }

    // Queue a mutation so rapid actions never race the gift engine.
    // `fn` resolves to the mutation's parsed response, which (because the
    // mutation requested `sections`) carries the re-rendered drawer HTML — so
    // we paint straight from it (applyResult) instead of firing a separate
    // refresh(). That's the speed win: one round-trip, not four.
    enqueue(fn) {
      var self = this;
      this._chain = this._chain
        .then(() => { self.setLoading(true); self.hideMutationError(); return fn(); })
        .then((res) => {
          var applied = self.applyResult(res);
          if (!applied) return self.refresh().then(() => null); // response had no sections — fall back
          return self.renderCartBits(res);
        })
        .then((cart) => { pub({ source: 'e5-cart-drawer' }); return self.syncGifts(cart); })
        .catch((e) => {
          console.error('[e5-cart] mutation', e);
          // Order matters: refresh() re-renders #CartDrawer's innerHTML —
          // which CONTAINS the error banner — so it would wipe any message
          // shown before it. Resync to server truth FIRST (this also snaps a
          // stale optimistic qty stepper back to the real cart value), THEN
          // paint the error onto the freshly-rendered banner. Guard refresh's
          // own catch so a refresh failure can't leave an unhandled rejection
          // that breaks the serialised chain.
          return self.refresh().catch(() => {}).then(() => self.showMutationError(e && e.message));
        })
        .finally(() => self.setLoading(false));
      return this._chain;
    }

    changeLine(key, quantity, sellingPlan) {
      var body = { id: key, quantity: quantity, sections: SECTIONS, sections_url: window.location.pathname };
      if (sellingPlan !== undefined) body.selling_plan = sellingPlan; // '' detaches
      return this.postJSON(this.routes().change, body).then((r) => r.json());
    }

    // Best-fit subscription cadence for a line: qty x months-per-bottle, matched
    // to the product's available selling plans (from data-plan-map / data-per-bottle
    // on the line). e.g. 3 bottles of a 2-month product -> the 6-month plan. Caps at
    // the longest plan the product offers. Returns a selling_plan id string, or
    // undefined if the product isn't cadence-scalable or has no usable plans.
    autoPlanId(lineEl, qty) {
      if (!lineEl) return undefined;
      var per = parseInt(lineEl.dataset.perBottle, 10) || 0;
      if (!per) return undefined;
      var map;
      try { map = JSON.parse(lineEl.dataset.planMap || '{}'); } catch (e) { return undefined; }
      var months = Object.keys(map).map(Number).filter((n) => n > 0).sort((a, b) => a - b);
      if (!months.length) return undefined;
      var target = Math.max(1, per * (parseInt(qty, 10) || 1));
      var pick = months[0];
      for (var i = 0; i < months.length; i++) { if (months[i] <= target) pick = months[i]; }
      if (target >= months[months.length - 1]) pick = months[months.length - 1];
      return map[pick] != null ? String(map[pick]) : undefined;
    }

    addVariant(variantId, sellingPlan, props) {
      var item = { id: parseInt(variantId, 10), quantity: 1 };
      if (sellingPlan) item.selling_plan = parseInt(sellingPlan, 10);
      if (props) item.properties = props;
      return this.postJSON(this.routes().add, { items: [item], sections: SECTIONS, sections_url: window.location.pathname }).then((r) => r.json());
    }

    // NMN bundle merge. After an NMN bundle variant is added, consolidate the
    // cart to a SINGLE bundle line per purchase type (subscription / one-time),
    // sized to the total months of that type (capped at 12 = the largest bundle).
    // A one-time line and a subscription line may coexist; adding more of one
    // type never touches the other, or any non-NMN product (gifts, upsells).
    mergeBundle(addedVariantId, addedPlan, addRes) {
      var self = this;
      var isSub = !!addedPlan;
      return NATIVE_FETCH(this.routes().cart + '.js', { headers: { Accept: 'application/json' } })
        .then((r) => r.json())
        .then(function (cart) {
          var same = (cart.items || []).filter(function (li) {
            if (li.product_id !== E5_BUNDLE.productId) return false;
            var onPlan = !!(li.selling_plan_allocation && li.selling_plan_allocation.selling_plan);
            return onPlan === isSub;
          });
          var totalMonths = 0;
          same.forEach(function (li) { totalMonths += e5bMonthsForVariant(li.variant_id) * (li.quantity || 1); });
          if (totalMonths > 12) totalMonths = 12;
          if (totalMonths < 2) totalMonths = 2;
          var targetVariant = e5bVariantFor(totalMonths);
          var targetPlan = isSub ? e5bPlanFor(totalMonths) : null;
          var alreadyClean = same.length === 1 && same[0].variant_id === targetVariant && (same[0].quantity || 1) === 1;
          if (alreadyClean) {
            if (!self.applyResult(addRes)) return self.refresh();
            return self.renderCartBits(addRes);
          }
          var seq = Promise.resolve(null);
          same.forEach(function (li) {
            seq = seq.then(function () { return self.postJSON(self.routes().change, { id: li.key, quantity: 0 }).then((r) => r.json()); });
          });
          seq = seq.then(function () {
            var item = { id: targetVariant, quantity: 1 };
            if (targetPlan) item.selling_plan = targetPlan;
            return self.postJSON(self.routes().add, { items: [item], sections: SECTIONS, sections_url: window.location.pathname }).then((r) => r.json());
          });
          return seq.then(function (lastRes) {
            if (!self.applyResult(lastRes)) return self.refresh();
            return self.renderCartBits(lastRes);
          });
        })
        .catch(function (e) { console.error('[e5-cart] bundle merge', e); return self.refresh(); });
    }

    // Fill each bundle line's contextual "Upgrade to N-month bundle - save X%"
    // hint (server renders it hidden; we know the sizes + prices client-side).
    paintBundleHints() {
      var lines = this.querySelectorAll('.e5cd__line[data-product-id="' + E5_BUNDLE.productId + '"]');
      Array.prototype.forEach.call(lines, function (line) {
        var hint = line.querySelector('[data-e5-size-hint]');
        if (!hint) return;
        var m = e5bMonthsForVariant(line.dataset.variantId) || 2;
        var isSub = line.dataset.onPlan === '1';
        if (m >= 12) { hint.hidden = true; hint.textContent = ''; return; }
        var next = m + 2;
        hint.hidden = false;
        hint.innerHTML = '&uarr; Upgrade to ' + next + '-month supply';
      });
    }

    // Find the cart line for a given variant id. Line keys are "<variantId>:<hash>",
    // so match on the prefix. Used by the "add one more" nudge to decide whether to
    // bump an existing subscribed line (re-fitting cadence) vs. add a fresh one.
    lineForVariant(variantId) {
      var lines = this.querySelectorAll('.e5cd__line[data-line-key]');
      for (var i = 0; i < lines.length; i++) {
        if (String(lines[i].dataset.lineKey).split(':')[0] === String(variantId)) return lines[i];
      }
      return null;
    }

    /* ---------------- free gift engine ---------------- */
    // Adds / removes £0 gift clones based on qualifying subtotal. Enforces:
    // one-time only (no selling plan), qty locked to 1, remove if unqualified.
    // `cart` (optional) is a cart object the caller already fetched (e.g. a
    // mutation response) — reuse it to skip a /cart.js round-trip in the
    // common case where no gift change is needed.
    syncGifts(cart) {
      if (this._giftBusy) return Promise.resolve();
      this._giftBusy = true;
      var self = this;
      return this._giftPass(cart)
        .catch((e) => console.error('[e5-cart] gift', e))
        .finally(() => { self._giftBusy = false; });
    }

    _giftPass(cart) {
      var self = this;
      var giftGoals = this.goals().filter((g) => g.reward_type === 'free_gift' && g.gift_variant_id);
      if (!giftGoals.length) return Promise.resolve();
      var total = this.qualifyingTotal(); // excludes gift lines (server-computed)

      var getCart = (cart && cart.items)
        ? Promise.resolve(cart)
        : NATIVE_FETCH(this.routes().cart + '.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());

      return getCart.then((c) => {
          var ops = [];
          giftGoals.forEach((g) => {
            var line = c.items.find((it) => it.id === g.gift_variant_id);
            var qualified = total >= g.threshold;
            if (qualified && !line) {
              ops.push({ type: 'add', id: g.gift_variant_id });
            } else if (!qualified && line) {
              ops.push({ type: 'remove', key: line.key });
            } else if (qualified && line && (line.quantity !== 1 || line.selling_plan_allocation)) {
              // Guard: force qty 1 and strip any selling plan
              ops.push({ type: 'fix', key: line.key });
            }
          });
          // Remove orphaned free gifts: any docapp gift line that isn't backed
          // by a CURRENT qualified goal (e.g. a gift from a dropped tier left in
          // an old cart). Current gifts are handled by the loop above.
          var currentGiftVars = giftGoals.map((g) => g.gift_variant_id);
          c.items.forEach((it) => {
            if (it.handle && it.handle.indexOf('docapp-free-gift-') === 0 && currentGiftVars.indexOf(it.id) === -1) {
              ops.push({ type: 'remove', key: it.key });
            }
          });
          if (!ops.length) return false;

          // Run gift ops sequentially; each requests `sections` so the LAST
          // one's response repaints the drawer (no separate refresh fetch).
          var seq = Promise.resolve(null);
          ops.forEach((op) => {
            seq = seq.then(() => {
              if (op.type === 'add') return self.postJSON(self.routes().add, { items: [{ id: op.id, quantity: 1 }], sections: SECTIONS, sections_url: window.location.pathname }).then((r) => r.json());
              if (op.type === 'remove') return self.postJSON(self.routes().change, { id: op.key, quantity: 0, sections: SECTIONS, sections_url: window.location.pathname }).then((r) => r.json());
              if (op.type === 'fix') return self.postJSON(self.routes().change, { id: op.key, quantity: 1, selling_plan: '', sections: SECTIONS, sections_url: window.location.pathname }).then((r) => r.json());
            });
          });
          return seq.then((lastRes) => {
            if (!self.applyResult(lastRes)) { return self.refresh(); }
            return self.renderCartBits(lastRes);
          }).then(() => { pub({ source: 'e5-cart-drawer' }); return true; });
        });
    }

    /* ---------------- discount codes ---------------- */
    currentCodes() {
      return Array.prototype.map.call(this.querySelectorAll('.e5cd__chip'), (c) => {
        var btn = c.querySelector('[data-code]');
        return btn ? btn.getAttribute('data-code') : '';
      }).filter(Boolean);
    }

    applyDiscount() {
      var input = this.querySelector('[data-e5-discount-input]');
      var err = this.querySelector('[data-e5-discount-error]');
      if (err) err.textContent = '';
      if (!input || !input.value.trim()) return;
      var code = input.value.trim();
      // Only one manually-entered code at a time — matches standard cart
      // behaviour (a normal cart's single discount field replaces, it doesn't
      // accumulate). Shopify's own combinesWith rules still govern whether a
      // code someone arrived with via a discount link stays applicable
      // alongside this one; we're not fighting that, just not letting our own
      // field stack arbitrary manually-typed codes on top of each other.
      var codes = [code];
      var self = this;
      // enqueue() -> refresh() replaces #CartDrawer's innerHTML, so `input`/`err`
      // above are stale by the time this resolves — re-query fresh nodes.
      this.enqueue(() => self.postJSON(self.routes().update, { discount: codes.join(','), sections: SECTIONS, sections_url: window.location.pathname }).then((r) => r.json()))
        .then(() => {
          var freshInput = self.querySelector('[data-e5-discount-input]');
          var freshErr = self.querySelector('[data-e5-discount-error]');
          if (freshInput) freshInput.value = '';
          var bad = self.querySelector('.e5cd__chip--invalid');
          if (freshErr) freshErr.textContent = bad ? 'That code can’t be applied to your cart.' : '';
        });
    }

    removeDiscount(code) {
      var codes = this.currentCodes().filter((c) => c !== code);
      var self = this;
      this.enqueue(() => self.postJSON(self.routes().update, { discount: codes.join(','), sections: SECTIONS, sections_url: window.location.pathname }).then((r) => r.json()));
    }

    /* ---------------- event handlers ---------------- */
    onClick(e) {
      var el = e.target.closest('[data-e5-action]');
      if (!el) return;
      var action = el.dataset.e5Action;
      // Instant feedback: show the loading overlay the moment a mutating
      // control is clicked, ahead of the debounce/network round-trip.
      var E5_MUT = { qty: 1, remove: 1, 'sub-on': 1, 'to-one-time': 1, add: 1, 'add-one-more': 1, 'bundle-size': 1, 'bundle-add-more': 1, 'bundle-swap-year': 1, 'apply-discount': 1, 'remove-discount': 1, 'mystery-discount': 1 };
      if (E5_MUT[action]) this.setLoading(true);

      if (action === 'close') { e.preventDefault(); return this.close(); }

      if (action === 'toggle-goal') { e.preventDefault(); return this.toggleGoal(); }

      if (action === 'qty') {
        e.preventDefault();
        var key = el.dataset.lineKey;
        var input = this.querySelector('.e5cd__qty-input[data-line-key="' + CSS.escape(key) + '"]');
        var to = parseInt(el.dataset.to, 10);
        if (input) {
          // Derive direction from the server value so rapid clicks accumulate
          // off the live input value (not the stale server-rendered data-to).
          var serverQty = parseInt(input.getAttribute('value'), 10);
          var dir = to > serverQty ? 1 : -1;
          to = Math.max(0, (parseInt(input.value, 10) || serverQty) + dir);
          input.value = to;
        }
        return this.debouncedQty(key, to);
      }

      if (action === 'bundle-size') {
        // NMN bundle line: step the SUPPLY SIZE (±2 months) instead of quantity.
        // Cadence follows the new size; minus below 2 months removes the line.
        e.preventDefault();
        var bsKey = el.dataset.lineKey;
        var bsLine = this.querySelector('.e5cd__line[data-line-key="' + CSS.escape(bsKey) + '"]');
        if (!bsLine) return;
        var curM = e5bMonthsForVariant(bsLine.dataset.variantId) || 2;
        var isSubB = bsLine.dataset.onPlan === '1';
        var newM = el.dataset.dir === 'up' ? Math.min(12, curM + 2) : curM - 2;
        var selfB = this;
        if (newM < 2) { return this.enqueue(function () { return selfB.changeLine(bsKey, 0); }); }
        if (newM === curM) return;
        var nvB = e5bVariantFor(newM), npB = isSubB ? e5bPlanFor(newM) : null;
        return this.enqueue(function () {
          return selfB.postJSON(selfB.routes().change, { id: bsKey, quantity: 0 }).then((r) => r.json())
            .then(function () { return selfB.addVariant(nvB, npB, bsLine.dataset.e5line ? { _e5line: bsLine.dataset.e5line } : null); });
        });
      }

      if (action === 'bundle-swap-year') {
        // Swap the new NMN bundle line for the cheaper legacy 1-Year bundle.
        // Removes the same-purchase-type new-bundle line(s), then adds the 1-Year
        // product (subscription if a plan id is provided, else one-time).
        e.preventDefault();
        var yVid = el.dataset.variantId, yPlan = el.dataset.planId || null;
        var isSubY = !!yPlan;
        var selfY = this;
        return this.enqueue(function () {
          return NATIVE_FETCH(selfY.routes().cart + '.js', { headers: { Accept: 'application/json' } })
            .then((r) => r.json())
            .then(function (cart) {
              var rm = (cart.items || []).filter(function (li) {
                if (li.product_id !== E5_BUNDLE.productId) return false;
                var onPlan = !!(li.selling_plan_allocation && li.selling_plan_allocation.selling_plan);
                return onPlan === isSubY;
              });
              var seq = Promise.resolve(null);
              rm.forEach(function (li) { seq = seq.then(function () { return selfY.postJSON(selfY.routes().change, { id: li.key, quantity: 0 }).then((r) => r.json()); }); });
              return seq.then(function () { return selfY.addVariant(yVid, yPlan); });
            });
        }).then(function () { selfY.open(); });
      }

      if (action === 'bundle-add-more') {
        // Deal Optimiser "add one more": grow the NMN bundle by a bottle (2 months).
        // Prefers the subscription line if both a sub and a one-time line exist.
        e.preventDefault();
        var selfN = this;
        return this.enqueue(function () {
          var bl = Array.prototype.slice.call(selfN.querySelectorAll('.e5cd__line[data-product-id="' + E5_BUNDLE.productId + '"]'));
          if (!bl.length) { return selfN.addVariant(e5bVariantFor(2), e5bPlanFor(2)); }
          var line = bl.filter(function (l) { return l.dataset.onPlan === '1'; })[0] || bl[0];
          var cM = e5bMonthsForVariant(line.dataset.variantId) || 2;
          var isS = line.dataset.onPlan === '1';
          var nM = Math.min(12, cM + 2);
          if (nM === cM) return null;
          var nv = e5bVariantFor(nM), np = isS ? e5bPlanFor(nM) : null;
          return selfN.postJSON(selfN.routes().change, { id: line.dataset.lineKey, quantity: 0 }).then((r) => r.json())
            .then(function () { return selfN.addVariant(nv, np, line.dataset.e5line ? { _e5line: line.dataset.e5line } : null); });
        }).then(function () { selfN.open(); });
      }

      if (action === 'remove') { e.preventDefault(); return this.enqueue(() => this.changeLine(el.dataset.lineKey, 0)); }

      if (action === 'sub-on') {
        // Switching a one-time line to subscribe: auto-pick the cadence that fits
        // qty x months-per-bottle (e.g. 3 bottles of a 2-month product -> 6 months),
        // falling back to the server's default plan id. Clears any prior manual
        // override for this product, since this is a fresh (automatic) subscribe.
        e.preventDefault();
        var q = parseInt(el.dataset.quantity, 10) || 1;
        var soKey = el.dataset.lineKey;
        var soLine = this.querySelector('.e5cd__line[data-line-key="' + CSS.escape(soKey) + '"]');
        var soPlan = this.autoPlanId(soLine, q) || el.dataset.planId;
        return this.enqueue(() => this.changeLine(soKey, q, soPlan));
      }

      if (action === 'to-one-time') {
        // Explicit "switch to one-time" link on a subscribed line — detach the
        // selling plan ('' removes it) so the line becomes a one-time purchase.
        e.preventDefault();
        var q1 = parseInt(el.dataset.quantity, 10) || 1;
        return this.enqueue(() => this.changeLine(el.dataset.lineKey, q1, ''));
      }

      if (action === 'add') {
        e.preventDefault();
        var vid = el.dataset.variantId;
        // Upsell subscribe checkbox (if present in same card)
        var card = el.closest('.e5cd__upsell-card');
        var plan;
        if (card) { var cb = card.querySelector('[data-e5-upsell-sub]'); if (cb && cb.checked) plan = cb.dataset.planId; }
        var self = this;
        return this.enqueue(() => self.addVariant(vid, plan)).then(() => self.open());
      }

      if (action === 'add-one-more') {
        // "Add one more [product] to unlock your next gift" nudge. If the variant
        // already has a SUBSCRIBED, cadence-scalable line, bump its qty AND re-fit
        // the cadence (qty x months-per-bottle) — same as the qty stepper — instead
        // of a plain add, which left the frequency stale (e.g. 3->4 NMN staying on
        // 6 months instead of moving to 8). Otherwise fall back to a normal add
        // (fresh line, or a one-time line that should stay one-time). Read the line
        // INSIDE the queued fn so it reflects the post-prior-mutation DOM (correct
        // qty on rapid clicks); the clicked button may be gone after a re-render.
        e.preventDefault();
        var selfN = this;
        var aoVariant = el.dataset.variantId;
        var aoPlan = el.dataset.planId;
        return this.enqueue(function () {
          var line = selfN.lineForVariant(aoVariant);
          if (line && line.querySelector('.e5cd__plan-select')) {
            var qi = line.querySelector('.e5cd__qty-input');
            var curQty = qi ? (parseInt(qi.getAttribute('value'), 10) || 1) : 1;
            var newQty = curQty + 1;
            return selfN.changeLine(line.dataset.lineKey, newQty, selfN.autoPlanId(line, newQty));
          }
          return selfN.addVariant(aoVariant, aoPlan);
        }).then(function () { selfN.open(); });
      }

      if (action === 'mystery-discount') {
        // One-tap "mystery" reveal: drop the real MYSTERYDISCOUNT code (5% off)
        // into the discount field and run the normal apply flow, so it shows
        // as a removable chip and carries to checkout like any typed code.
        e.preventDefault();
        var mi = this.querySelector('[data-e5-discount-input]');
        if (mi) mi.value = 'MYSTERYDISCOUNT';
        var mb = el; mb.classList.add('is-revealing');
        return this.applyDiscount();
      }

      if (action === 'toggle-discount') {
        e.preventDefault();
        var dp = this.querySelector('[data-e5-discount]');
        var dl = this.querySelector('[data-e5-disc-toggle-label]');
        if (dp) {
          dp.hidden = !dp.hidden;
          if (dl) dl.textContent = dp.hidden ? '+ Add Discount Code' : '− Hide Discount Code';
          if (!dp.hidden) { var di = dp.querySelector('[data-e5-discount-input]'); if (di) di.focus(); }
        }
        return;
      }

      if (action === 'apply-discount') { e.preventDefault(); return this.applyDiscount(); }
      if (action === 'remove-discount') { e.preventDefault(); return this.removeDiscount(el.dataset.code); }

      if (action === 'checkout') {
        // A discount applied via the Cart AJAX API (/cart/update.js) rides on
        // the cart's server-side session. That carries to checkout fine on the
        // canonical domain, but NOT across the shopifypreview.com proxy domain
        // (a shared preview link) — the code shows in the drawer but is dropped
        // at checkout (reported on mobile preview). Shopify's discount permalink
        // /discount/CODE?redirect=/checkout re-applies the code server-side and
        // is domain-independent, so route through it whenever a code is applied.
        // No code -> let the native form POST to /cart proceed unchanged.
        // Wrapped so any failure falls back to the normal checkout submit.
        try {
          var applicable = Array.prototype.map.call(
            this.querySelectorAll('.e5cd__chip:not(.e5cd__chip--invalid) [data-code]'),
            function (b) { return b.getAttribute('data-code'); }
          ).filter(Boolean);
          if (applicable.length) {
            e.preventDefault();
            window.location.href = '/discount/' + applicable.map(encodeURIComponent).join(',') + '?redirect=%2Fcheckout';
          }
        } catch (err) { /* fall through to native form submit */ }
        return;
      }
    }

    onChange(e) {
      var t = e.target;
      if (t.matches('[data-e5-qty-input]')) {
        this.setLoading(true);
        var to = Math.max(0, parseInt(t.value, 10) || 0);
        t.value = to;
        return this.debouncedQty(t.dataset.lineKey, to);
      }
      if (t.matches('[data-e5-action="bundle-pick"]')) {
        // Direct size pick from the dropdown: swap to the chosen supply variant
        // (keeping subscription/one-time), same as the +/- stepper.
        this.setLoading(true);
        var pkKey = t.dataset.lineKey;
        var pkLine = this.querySelector('.e5cd__line[data-line-key="' + CSS.escape(pkKey) + '"]');
        var pkCur = pkLine ? (e5bMonthsForVariant(pkLine.dataset.variantId) || 2) : 2;
        var pkNew = parseInt(t.value, 10) || pkCur;
        var pkSub = pkLine ? pkLine.dataset.onPlan === '1' : false;
        if (pkNew === pkCur) { this.setLoading(false); return; }
        var pkV = e5bVariantFor(pkNew), pkP = pkSub ? e5bPlanFor(pkNew) : null;
        var selfPk = this;
        return this.enqueue(function () {
          return selfPk.postJSON(selfPk.routes().change, { id: pkKey, quantity: 0 }).then((r) => r.json())
            .then(function () { return selfPk.addVariant(pkV, pkP, pkLine.dataset.e5line ? { _e5line: pkLine.dataset.e5line } : null); });
        });
      }
      if (t.matches('[data-e5-action="plan-select"]')) {
        this.setLoading(true);
        var qty = parseInt(t.dataset.quantity, 10) || 1;
        var plan = t.value; // '' = one-time purchase, otherwise a selling_plan id
        // A hand-picked cadence is applied as-is and simply sticks until the next
        // quantity change, at which point debouncedQty re-fits it automatically.
        return this.enqueue(() => this.changeLine(t.dataset.lineKey, qty, plan));
      }
      if (t.matches('[data-e5-upsell-sub]')) {
        // Keep the upsell price honest with the toggle: plan price when
        // Subscribe is on (the default), one-time price when off.
        var upCard = t.closest('.e5cd__upsell-card');
        if (upCard) {
          var upNow = upCard.querySelector('[data-e5-up-now]');
          var upWas = upCard.querySelector('[data-e5-up-was]');
          var curU = this.currency();
          var subP = parseInt(upCard.dataset.subPrice, 10) || 0;
          var onceP = parseInt(upCard.dataset.oncePrice, 10) || 0;
          var compP = parseInt(upCard.dataset.comparePrice, 10) || 0;
          // Match the Liquid `| money` output on this shop (no leading symbol)
          // so toggling doesn't flip a £ on/off vs the initial render.
          var fmt = function (c) { return money(c, curU).replace(/^\D+/, ''); };
          if (t.checked && subP) {
            if (upNow) upNow.textContent = fmt(subP);
            if (upWas) { upWas.textContent = fmt(onceP); upWas.hidden = false; }
          } else {
            if (upNow) upNow.textContent = fmt(onceP);
            if (upWas) { if (compP > onceP) { upWas.textContent = fmt(compP); upWas.hidden = false; } else { upWas.hidden = true; } }
          }
          var upPer = upCard.querySelector('[data-e5-up-permo]');
          if (upPer) {
            var pm = parseInt(upPer.dataset.months, 10) || 1;
            var basePer = (t.checked && subP) ? subP : onceP;
            upPer.textContent = fmt(Math.round(basePer / pm)) + '/mo';
          }
        }
        return;
      }
    }

    onToggle(e) {
      var el = e.target;
      if (!el || !el.matches || !el.matches('.e5cd__discount-toggle')) return;
      var summary = el.querySelector('summary');
      if (!summary) return;
      summary.textContent = el.open ? '− Hide Discount Code' : '+ Add Discount Code';
    }

    debouncedQty(key, quantity) {
      var self = this;
      clearTimeout(this._qtyTimers[key]);
      this._qtyTimers[key] = setTimeout(() => {
        // Any quantity change re-fits a subscribed line's cadence to the new qty
        // (qty x months-per-bottle). This intentionally OVERRIDES an earlier manual
        // cadence pick: a hand-picked cadence sticks only until the shopper next
        // changes the unit count, after which auto-cadence resumes for good. plan
        // stays undefined for one-time lines => changeLine keeps them one-time.
        var plan;
        if (quantity > 0) {
          var lineEl = self.querySelector('.e5cd__line[data-line-key="' + CSS.escape(key) + '"]');
          if (lineEl && lineEl.querySelector('.e5cd__plan-select')) {
            var auto = self.autoPlanId(lineEl, quantity);
            if (auto) plan = auto;
          }
        }
        self.enqueue(() => self.changeLine(key, quantity, plan));
      }, DEBOUNCE);
    }
  }

  if (!customElements.get('cart-drawer')) {
    customElements.define('cart-drawer', E5CartDrawer);
  }
})();

